import { InjectionToken, Provider } from '@angular/core'

export interface AchTransactionDetailsConfig {
    bffBaseUrl: string
}

export const ACH_TRANSACTION_DETAILS_CONFIG = new InjectionToken<AchTransactionDetailsConfig>(
    'AchTransactionDetailsConfig'
)

export function provideAchTransactionDetails(config: AchTransactionDetailsConfig): Provider {
    return { provide: ACH_TRANSACTION_DETAILS_CONFIG, useValue: config }
}
